/* unplugin-vue-components disabled */import script from "./HotelStockPriceOperate.vue?vue&type=script&setup=true&lang=js"
export * from "./HotelStockPriceOperate.vue?vue&type=script&setup=true&lang=js"

import "./HotelStockPriceOperate.vue?vue&type=style&index=0&id=20a872b6&lang=scss"

const __exports__ = script;

export default __exports__